import { addMethod, string, object } from 'yup';

const phoneValidation = value => {
  if (!value) {
    return false;
  }

  return value.length >= 5 && value.length <= 18;
};

addMethod(string, 'checkPhone', function (message) {
  return this.test('checkPhone', message, function (value) {
    return phoneValidation(value);
  });
});

const phone = messages => {
  const message = 'Please, enter your phone number';

  return string()
    .required(messages || message)
    .checkPhone(messages || message);
};

export const contactFormSchema = messages => {
  return object().shape({
    event: string().required(messages.event),
    name: string().required(messages.name),
    phone: phone(messages.phone),
    email: string().email(messages.email).required(messages.email),
  });
};
